import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

export function LampDemo() {
  return (
    <LampContainer>
      <motion.h1
        initial={{ opacity: 0.5, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="mt-8 bg-gradient-to-br from-slate-300 to-slate-500 py-4 bg-clip-text text-center text-4xl font-medium tracking-tight text-transparent md:text-7xl"
      >
        Build lamps <br /> the right way
      </motion.h1>
    </LampContainer>
  );
}

export const LampContainer = ({
  children,
  className,
  lampClassName,
  contentClassName,
  overlay,
}: {
  children: React.ReactNode;
  className?: string;
  lampClassName?: string;
  contentClassName?: string;
  overlay?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-slate-950 w-full rounded-md z-0 pt-24 md:pt-40",
        className
      )}
    >
      <div
        className={cn(
          "relative flex w-full flex-1 scale-x-[0.5] scale-y-125 sm:scale-x-75 md:scale-x-100 items-center justify-center isolate z-0 ",
          lampClassName
        )}
      >
        <motion.div
          initial={{ opacity: 0.5, width: "20rem" }}
          whileInView={{ opacity: 1, width: "40rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          style={{
            backgroundImage: `conic-gradient(var(--conic-position), var(--tw-gradient-stops))`,
          }}
          className="absolute inset-auto right-1/2 h-56 overflow-visible w-[40rem] bg-gradient-conic from-quantum-blue via-transparent to-transparent text-white [--conic-position:from_70deg_at_center_top]"
        >
          <div className="absolute  w-[100%] left-0 bg-slate-950 h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)]" />
          <div className="absolute  w-40 h-[100%] left-0 bg-slate-950  bottom-0 z-20 [mask-image:linear-gradient(to_right,white,transparent)]" />
        </motion.div>
        <motion.div
          initial={{ opacity: 0.5, width: "20rem" }}
          whileInView={{ opacity: 1, width: "40rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          style={{
            backgroundImage: `conic-gradient(var(--conic-position), var(--tw-gradient-stops))`,
          }}
          className="absolute inset-auto left-1/2 h-56 w-[40rem] bg-gradient-conic from-transparent via-transparent to-quantum-blue text-white [--conic-position:from_290deg_at_center_top]"
        >
          <div className="absolute  w-40 h-[100%] right-0 bg-slate-950  bottom-0 z-20 [mask-image:linear-gradient(to_left,white,transparent)]" />
          <div className="absolute  w-[100%] right-0 bg-slate-950 h-40 bottom-0 z-20 [mask-image:linear-gradient(to_top,white,transparent)]" />
        </motion.div>
        <div className="absolute top-1/2 h-48 w-full translate-y-12 scale-x-150 bg-slate-950 blur-2xl"></div>
        <div className="absolute top-1/2 z-50 h-48 w-full bg-transparent opacity-10 backdrop-blur-md"></div>
        <div className="absolute inset-auto z-50 h-44 w-[36rem] -translate-y-1/2 rounded-full bg-quantum-blue opacity-50 blur-3xl"></div>
        <motion.div
          initial={{ width: "10rem" }}
          whileInView={{ width: "22rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          className="absolute inset-auto z-30 h-44 w-64 -translate-y-[6rem] rounded-full bg-[#3E71C4] blur-2xl"
        ></motion.div>
        <motion.div
          initial={{ width: "20rem" }}
          whileInView={{ width: "40rem" }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: "easeInOut",
          }}
          className="absolute inset-auto z-50 h-0.5 w-[40rem] -translate-y-[7rem] bg-[#3E71C4]"
        ></motion.div>

        <div className="absolute inset-auto z-40 h-44 w-[200vw] -translate-y-[12.5rem] bg-slate-950 "></div>
      </div>

      {/* Camada de fundo sobre o efeito, abaixo do texto. Padrão: foto do hero antigo de Soluções */}
      {overlay !== undefined ? (
        overlay
      ) : (
        <div
          className="absolute inset-0 z-10 bg-cover bg-center opacity-[0.15] pointer-events-none"
          style={{ backgroundImage: "url('/img/solucoes/solucoes.jpg')" }}
        />
      )}

      <div
        className={cn(
          "relative z-50 flex -translate-y-52 flex-col items-center px-5",
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};
